module.exports = __webpack_public_path__ + "98d34fe91c32fb2c936202d8f4cbe29a.svg";